module.exports = {
	"en": {
		"comparison_tool_title": "Comparison tool",
		"calendar_tool_title": "Calendar tool",
		"new_search_button": "New search",
		"comparison_tool_scope_title": "What are you looking for ?",
		"comparison_tool_place_title": "For what theatre ?",
		"comparison_tool_time_scope_title": "For what period ?",
		"comparison_tool_x_title": "x. In function of what ?",
		"comparison_tool_y_title": "y. In function of what ?",
		"comparison_tool_open_handle": "Search criterias",
		"filter_button_all": "Use all filters",
		"filter_button_clear_all": "Clear all filters",
		"sum_receipts": "Gross receipts",
		"sum_receipts_weighted": "Gross receipts (weighted)",
		"performances_days": "Performances (= days)",
		"mean_receipts_day": "Average receipts / day",
		"mean_receipts_day_weighted": "Average receipts / day (weighted)",
		"mean_price": "Average ticket price",
		"count_authors": "Count author",
		"count_titles": "Count title",
		"rows": "Rows",
		"cols": "Columns",
		"cells": "Cells",
		"find": "Search",
		"all": "All",
		"ok": "OK",
		"from": "From",
		"to": "To",
		"time": "Time",
		"performance": "Performance",
		"performance_addl": "Performance (additional)",
		"theater": "Theater",
		"decade": "Decade",
		"decade_hint": "for decade {decade}",
		"season": "Season",
		"season_hint": "during the season of {season}",
		"month": "Month",
		"month_hint": "for {month}",
		"day": "Day",
		"weekday": "Weekday",
		"weekday_hint": "on {weekday}",
		"author": "Author",
		"author_n": "Author",
		"author_n_hint": "for author {author_1}",
		"author_1": "Author (overture)",
		"author_1_hint": "when {author_1} is presented during overture",
		"author_2": "Author (2nd part)",
		"author_2_hint": "when {author_2} is presented in 2nd part",
		"author_3": "Author (3rd part)",
		"author_3_hint": "when {author_3} is presented in 3rd part",
		"title": "Title",
		"title_n": "Title",
		"title_n_hint": "for {title}",
		"title_1": "First title",
		"title_1_hint": "where the first title is {title_1}",
		"title_2": "Second title",
		"title_2_hint": "where the second title is {title_2}",
		"title_3": "Third title",
		"title_3_hint": "where the third title is {title_3}",
		"genre": "Genre",
		"genre_n": "Genre",
		"genre_n_hint": "for the {genre} genre",
		"genre_1": "Genre (overture)",
		"genre_1_hint": "where the first title is a {genre_1} genre",
		"genre_2": "Genre (2nd part)",
		"genre_2_hint": "where the third title is a {genre_3} genre",
		"genre_3": "Genre (3rd part)",
		"acts": "Acts",
		"acts_hint": "for act {acts}",
		"prose_vers": "Prose/Verse",
		"prologue": "Prolog",
		"musique_danse_machine": "Music/Dance/Machinery",
		"free_entry": "Free Entry",
		"firstrun": "First Run",
		"reprise": "Reprise",
		"newactor": "New Actor",
		"debut": "Debut",
		"ex_attendance": "VIP",
		"ex_representation": "Notable performance",
		"ex_place": "Notable place",
		"theater_period": "Theater + Period",
		"seating_area": "Seat"
	},
	"fr": {
		"comparison_tool_title": "Outil de comparaison",
		"calendar_tool_title": "Outil calendrier",
		"new_search_button": "Nouvelle recherche",
		"comparison_tool_scope_title": "Que cherchez-vous ?",
		"comparison_tool_place_title": "Pour quelle salle ?",
		"comparison_tool_time_scope_title": "Selon quelle période ?",
		"comparison_tool_x_title": "x. En fonction de quoi ?",
		"comparison_tool_y_title": "y. En fonction de quoi ?",
		"comparison_tool_open_handle": "Critères de recherche",
		"filter_button_all": "Utiliser tous les filtres",
		"filter_button_clear_all": "Supprimer les filtres",
		"sum_receipts": "Somme des recettes",
		"sum_receipts_weighted": "Somme recette (pondérée)",
		"performances_days": "Représentations / jour",
		"mean_receipts_day": "Moyenne des recettes / jour",
		"mean_receipts_day_weighted": "Moyenne recette/jour (pondérée)",
		"mean_price": "Moyenne du prix des places",
		"count_authors": "Nombre d'auteurs",
		"count_titles": "Nombre de pièces",
		"rows": "Lignes",
		"cols": "Colonnes",
		"cells": "Cellules",
		"find": "Rechercher",
		"all": "Tous",
		"ok": "OK",
		"from": "De",
		"to": "À",
		"time": "Période",
		"performance": "Pièce",
		"performance_addl": "Soirée (supplémentaire)",
		"theater": "Salle",
		"decade": "Décennie",
		"decade_hint": "pour la décennie {decade}",
		"season": "Saison",
		"season_hint": "durant la saison de {season}",
		"month": "Mois",
		"month_hint": "pour {month}",
		"day": "Jour",
		"weekday": "Jour de la semaine",
		"weekday_hint": "pour le {weekday}",
		"author": "Auteur",
		"author_n": "Auteur",
		"author_n_hint": "pour l'auteur {author_1}",
		"author_1": "Auteur de la première pièce",
		"author_1_hint": "lorsque {author_1} est en 1ère partie",
		"author_2": "Auteur de la seconde pièce",
		"author_2_hint": "lorsque {author_2} est en 2e partie",
		"author_3": "Auteur de la troisième pièce",
		"author_3_hint": "lorsque {author_3} est en 3e partie",
		"title": "Pièce",
		"title_n": "Pièce",
		"title_n_hint": "pour la pièce {title}",
		"title_1": "Première pièce",
		"title_1_hint": "dont la 1ère pièce est {title_1}",
		"title_2": "Seconde pièce",
		"title_2_hint": "dont la 2e pièce est {title_2}",
		"title_3": "Troisième pièce",
		"title_3_hint": "dont la 3e pièce est {title_3}",
		"genre": "Genre",
		"genre_n": "Genre",
		"genre_n_hint": "des {genre}s",
		"genre_1": "Genre de la première pièce",
		"genre_1_hint": "dont le genre de la 1ère pièce est {genre_1}",
		"genre_2": "Genre de la seconde pièce",
		"genre_2_hint": "dont le genre de la 2e pièce est {genre_2}",
		"genre_3": "Genre de la troisième pièce",
		"genre_3_hint": "dont le genre de la 3e pièce est {genre_3}",
		"acts": "Acte(s)",
		"acts_hint": "pour l'acte {acts}",
		"prose_vers": "Prose/Vers",
		"prologue": "Prologue",
		"musique_danse_machine": "Musique/Danse/Machine",
		"free_entry": "Gratuit",
		"firstrun": "First Run",
		"reprise": "Reprise",
		"newactor": "Nouvel Acteur",
		"debut": "Début",
		"ex_attendance": "Présence exceptionelle",
		"ex_representation": "Répresentation exceptionelles",
		"ex_place": "ExPlace",
		"theater_period": "Théâtre + Période",
		"seating_area": "Place",
		"seating_area_hint": "pour la place {seating_area}"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./i18n/query.json
// module id = 3
// module chunks = 0